package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository

class GetAllCharactersUseCase(
    private val characterRepository: CharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(userId: String): Result<List<Character>> {
        return characterRepository.getAllCharactersByUserId(userId)
            .map { characters ->
                characters.map { character ->
                    if (character.imageUrl != null) {
                        val signedUrlResult = imageStorageRepository.getSignedUrl(
                            character.imageUrl,
                            version = character.updatedAt.toString()
                        )
                        if (signedUrlResult.isSuccess) {
                            character.copy(signedImageUrl = signedUrlResult.getOrThrow())
                        } else {
                            character
                        }
                    } else {
                        character
                    }
                }.sortedByDescending { it.createdAt }
            }
    }
}
